import { useParams } from 'react-router-dom';

import { Server1Wizard } from './wizards/Server1Wizard';
import { Server2Wizard } from './wizards/Server2Wizard';
import { Server3Wizard } from './wizards/Server3Wizard';
import { Server4Wizard } from './wizards/Server4Wizard';
import { Server5Wizard } from './wizards/Server5Wizard';

export function PurchaseProxyWizard() {
  const { serverId } = useParams<{ serverId: string }>();
  const serverIdNum = Number(serverId);

  switch (serverIdNum) {
    case 1:
      return <Server1Wizard />;
    case 2:
      return <Server2Wizard />;
    case 3:
      return <Server3Wizard />;
    case 4:
      return <Server4Wizard />;
    case 5:
      return <Server5Wizard />;
    default:
      return (
        <div className="text-center py-12">
          <p className="text-neutral-medium font-body">Invalid server ID</p>
        </div>
      );
  }
}

